import React, { useState, useRef, useEffect } from "react";
import { IonApp, IonContent, IonHeader, IonIcon, IonItem, IonLabel, IonList, IonMenu, IonMenuToggle, IonPage, IonRadio, IonRadioGroup, IonTitle, IonToolbar } from '@ionic/react';
import topics from "../../menus/LKG/English";
import { Helmet } from "react-helmet";

const English: React.FC = () => {

    const handleSubmit = (url: string) => {
        window.location.href = url;
    }

    useEffect(() => {
        document.title = "Mamas Guidance - LKG - English"; // Set page title
    }, []);

    return (
        <>
            <Helmet>
                <meta name="description" content='Discover engaging English language activities for LKG students on Mama’s Guidance—featuring Phonetic Words, Articles, One and Many, Rhyming Words, Vowel Consonant, This-That, Opposite Words exercises, and fun reading & writing practice to boost early literacy skills in a playful, child-friendly format.' />
            </Helmet>
            <div className={`my-topic-container`}>
                {topics.map((slide, index) => (
                    <IonItem key={index} routerLink={slide.url}
                        routerDirection="none"
                        lines="none"
                        detail={true}>
                        <IonLabel>{slide.title}</IonLabel>
                    </IonItem>
                ))}
            </div>
        </>
    );
};
export default English;